import React from 'react';

import { Button } from '../../form';
import * as Styled from './styles';

/**
 * Componente de caixa de informação com link.
 * @param {object} props - Propriedades do componente.
 * @param {boolean} props.shadowy - Indica se a caixa deve ter sombra.
 * @param {JSX.Element} props.icon - Ícone a ser exibido na caixa.
 * @param {string} props.text - Texto a ser exibido na caixa.
 * @param {string} [props.textColor="#018383"] - Cor do texto.
 * @param {string} props.buttonText - Texto do botão.
 * @param {string} props.link - URL para o qual o botão deve redirecionar.
 * @param {boolean} [props.subscribed=false] - Indica se o usuário está inscrito.
 * @param {boolean} [props.buttonDisabled=false] - Indica se o botão está desabilitado.
 * @returns {JSX.Element} O componente BoxInfoLink.
 */
const BoxInfoLink = ({ shadowy, icon, text, textColor = '#018383', buttonText, link, subscribed = false, buttonDisabled = false }) => {
	return (
		<Styled.Box>
			<Styled.Wrapper>
				{icon}
				<Styled.Info color={textColor}>{text}</Styled.Info>
			</Styled.Wrapper>
			<Button disabled={buttonDisabled} type={'button'} shadowy={shadowy} link={link} title={buttonText}></Button>
		</Styled.Box>
	);
};

export default BoxInfoLink;
